import React, { useContext, useEffect, useState } from "react";
import Utils from "../../../utils/Utils";
import { AppContext } from "../../../context/AppContext";
import EventsSelecter from "./EventsSelecter";
import { Switch } from "antd";

import * as Io5 from "react-icons/io5";
import * as Fa6 from "react-icons/fa6";
import { toast } from "react-toastify";

function ViewEvents({
  selected,
  setIsEditing,
  fmtShort,
  isEditing,
  setSelected,
}) {
  const { eventsLoading, updateSingleEvent, getEvents, handleEventsList } =
    useContext(AppContext);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [editForm, setEditForm] = useState(null);

  const onDelete = async () => {
    // await deleteEvent(selected.event_id)
    setSelected(null);
  };

  useEffect(() => {
    if (selected) {
      setIsEditing(false);
      setEditForm({
        event_id: selected.event_id,
        event_title: selected.event_title || "",
        event_start: selected.event_start
          ? selected.event_start.slice(0, 16)
          : "",
        event_end: selected.event_end ? selected.event_end.slice(0, 16) : "",
        event_type: selected.event_type || "",
        menu_type: selected.menu_type || "",
        menu_title: selected.menu?.title || "",
        maxAttendees: selected.maxAttendees ?? "",
        active: !!Number(selected.active),
        shopId: selected.shopId ?? "",
        event_description: selected.event_description ?? "",
      });
    } else {
      setIsEditing(false);
      setEditForm(null);
    }
  }, [selected]);

  const onEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSubmitLoading(true);
      const payload = {
        event_id: editForm.event_id,
        event_title: editForm.event_title,
        event_start: editForm.event_start,
        event_end: editForm.event_end,
        event_type: editForm.event_type,
        active: editForm.active,
        menu_type: editForm.menu_type,
        menu_id: editForm.menu_id,
        maxAttendees: editForm.maxAttendees,
        promotions: editForm.promotions,
        event_description: editForm.event_description,
      };

      await updateSingleEvent(payload, {
        onSuccess: async (res) => {
          toast.success("Updated sucessfully!");
          await getEvents();
          setTimeout(() => {
            
            setIsEditing(false);
            setSelected(null);
          }, 1200);
        },
        onFailed: (err) => {
          toast.error("Updation Failed!");
        },
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <aside
      className={`details-pane ${selected ? "open" : ""}`}
      aria-hidden={!selected}
    >
      {selected && (
        <div className="card shadow-sm h-100">
          <div className="card-header d-flex justify-content-between align-items-center gap-2">
            <h6 className="mb-0 text-truncate">{selected.event_title}</h6>
            <div className="d-flex gap-2">
              {!isEditing ? (
                <button
                  className="event_btn event_btn_edit"
                  onClick={() => setIsEditing(true)}
                >
                  Edit
                </button>
              ) : (
                // <button
                //   className="event_btn event_btn_cancel"
                //   onClick={() => setIsEditing(false)}
                // >
                //   Cancel
                // </button>
                <button
                  type="button"
                  className="event_btn event_btn_delete"
                  onClick={onDelete}
                >
                  <Fa6.FaRegTrashCan />
                </button>
              )}
              <button
                className="close-btn_new"
                onClick={() => setSelected(null)}
                aria-label="Close details"
              >
                <Io5.IoClose />
              </button>
            </div>
          </div>

          <div className="card-body">
            {!isEditing ? (
              // ======== READ-ONLY VIEW ========
              <div className="row g-3">
                <div className="col-12">
                  <strong>Title:</strong> {selected.event_title}
                </div>
                <div className="col-md-6">
                  <strong>Start:</strong> {fmtShort(selected.event_start)}
                </div>
                <div className="col-md-6">
                  <strong>End:</strong> {fmtShort(selected.event_end)}
                </div>
                <div className="col-md-6">
                  <strong>Type:</strong> {selected?.event_type || "—"}
                </div>
                <div className="col-md-6">
                  <strong>Menu Type:</strong> {selected.menu_type || "—"}
                </div>
                <div className="col-md-6">
                  <strong>Menu:</strong> {selected.menu?.title ?? "—"}
                </div>
                <div className="col-md-6">
                  <strong>Max Attendees:</strong> {selected.maxAttendees ?? "—"}
                </div>
                <div className="col-md-6">
                  <strong>Active:</strong>{" "}
                  {Number(selected.active) ? "Yes" : "No"}
                </div>

                <div className="col-12">
                  <strong>Description:</strong>{" "}
                  {selected.event_description ?? "—"}
                </div>
                {selected?.promotions && (
                  <div className="col-12">
                    <strong>Promotions:</strong> {selected.promotions ?? "—"}
                  </div>
                )}
                <div className="col-12">
                  <strong>Created At:</strong>{" "}
                  {Utils.formatDate(selected.created_at)}
                </div>
              </div>
            ) : (
              // ======== EDIT FORM ========
              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-12">
                  <label className="form-label">Title</label>
                  <input
                    name="event_title"
                    className="form-control"
                    value={editForm?.event_title || ""}
                    onChange={onEditChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Start</label>
                  <input
                    type="datetime-local"
                    name="event_start"
                    className="form-control"
                    value={editForm?.event_start || ""}
                    onChange={onEditChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">End</label>
                  <input
                    type="datetime-local"
                    name="event_end"
                    className="form-control"
                    value={editForm?.event_end || ""}
                    onChange={onEditChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Type</label>
                  {/* <select
                      name="event_type"
                      className="form-select"
                      value={editForm?.event_type || ""}
                      onChange={onEditChange}
                    >
                      <option value="">Select type…</option>
                      <option value="birthday">Birthday</option>
                      <option value="wedding">Wedding</option>
                      <option value="engagement">Engagement</option>
                      <option value="anniversary">Anniversary</option>
                      <option value="conference">Conference</option>
                      <option value="seminar">Seminar</option>
                      <option value="meeting">Meeting</option>
                      <option value="party">Party</option>
                      <option value="concert">Concert</option>
                      <option value="festival">Festival</option>
                      <option value="other">Other</option>
                    </select> */}
                  <EventsSelecter
                    handleChange={onEditChange}
                    eventDetails={editForm}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="menu_type" className="form-label">
                    Menu Type
                  </label>
                  <select
                    name="menu_type"
                    className="form-select"
                    onChange={onEditChange}
                    value={editForm?.menu_type}
                  >
                    <option value="default">Default</option>
                    <option value="special">Special</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Max Attendees</label>
                  <input
                    type="number"
                    name="maxAttendees"
                    className="form-control"
                    min="0"
                    value={editForm?.maxAttendees}
                    onChange={onEditChange}
                  />
                </div>

                <div className="col-md-6 d-flex align-items-end">
                  <div className="form-group">
                    {/* <input
                        id="eventActive"
                        type="checkbox"
                        className="form-check-input"
                        name="active"
                        checked={!!editForm?.active}
                        onChange={onEditChange}
                      />*/}
                    <label className="form-label">Status</label>
                    <br />
                    <Switch
                      checked={editForm?.active}
                      onChange={(e) => {
                        setEditForm((prev) => ({ ...prev, active: e }));
                      }}
                      value={editForm?.active}
                    />
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    name="event_description"
                    className="form-control"
                    rows={3}
                    value={editForm?.event_description}
                    onChange={onEditChange}
                  />
                </div>
                <br />
                <div className="col-12 d-flex justify-content-between align-items-center mt-2">
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="event_btn event_btn_cancel"
                      onClick={() => setIsEditing(false)}
                      disabled={submitLoading}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="event_btn event_btn_save"
                      disabled={submitLoading}
                    >
                      <Fa6.FaCheck /> Save Changes
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </aside>
  );
}

export default ViewEvents;
